import type { ReactNode } from 'react';

import { DictationRuntimeContext } from './runtimeContext';
import type { DictationRuntime } from './types';

/**
 * Supplies the engine, microphone capture, token source, and analytics sink to
 * every dictation control below it. Without a provider the controls render
 * nothing, so presentation-only stories and tests stay pure.
 */
export function DictationRuntimeProvider({
  runtime,
  children,
}: {
  runtime: DictationRuntime | null;
  children: ReactNode;
}) {
  return (
    <DictationRuntimeContext.Provider value={runtime}>{children}</DictationRuntimeContext.Provider>
  );
}
